export type BalanceCashPaymentRequestBody = {
  paymentDiscriminator: BalanceCashPaymentRequestBody.paymentDiscriminator;
  paymentMethod: BalanceCashPaymentRequestBody.paymentMethod;
  dueDate: string;
  cashRegisterId: string;
  comment: string;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace BalanceCashPaymentRequestBody {
  export enum paymentDiscriminator {
    BALANCE = 'BALANCE',
  }

  export enum paymentMethod {
    CASH = 'CASH',
  }
}
